import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggleJobBookmark } from "app/api/candidate_api";

const useToggleBookmark = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ jobId }) => toggleJobBookmark(jobId),
    onMutate: async ({ jobId }) => {
      await queryClient.cancelQueries({ queryKey: ["recommended-jobs"] });

      const previousRecommendedJobs = queryClient.getQueriesData({
        queryKey: ["recommended-jobs"]
      });

      queryClient.setQueriesData({ queryKey: ["recommended-jobs"] }, (oldData) => {
        if (!oldData?.rows) return oldData;

        return {
          ...oldData,
          rows: oldData.rows.map((job) =>
            job.jp_id === jobId
              ? {
                  ...job,
                  isBookmarked: !job.isBookmarked
                }
              : job
          )
        };
      });

      return { previousRecommendedJobs };
    },
    onError: (error, variables, context) => {
      context?.previousRecommendedJobs?.forEach(([queryKey, data]) => {
        queryClient.setQueryData(queryKey, data);
      });

      onError?.(error, variables, context);
    },
    onSuccess: (data, variables, context) => {
      onSuccess?.(data, variables, context);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["recommended-jobs"] });
      queryClient.invalidateQueries({ queryKey: ["bookmarked-jobs"] });
      queryClient.invalidateQueries({ queryKey: ["job_listings"] });
    }
  });
};

export default useToggleBookmark;
